/* eslint-disable consistent-return */
/* eslint-disable no-console */
import {createAsyncThunk} from '@reduxjs/toolkit'
import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios'
import {ROOTS} from 'hiya-common/config'
import {RootState, StoreType} from 'hiya-common/src/stores'
import {useSelector} from 'react-redux'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {ApiHost} from '../constant'
import {isNode} from './index'

axios.defaults.timeout = 10000
class MyRequest {
  protected service: AxiosInstance = axios

  private static instance: MyRequest

  public IS_NODE: boolean

  constructor() {
    this.IS_NODE = isNode()
    this.service = axios.create(this.requestConfig())
    this.interceptorsRequest()
    this.interceptorsResponse()
  }

  public log: any

  setPublicFunction({log}) {
    this.log = log
  }

  /**
   * 初始化配置
   */
  protected requestConfig(): AxiosRequestConfig {
    return {
      baseURL: this.IS_NODE
        ? ROOTS.host[ENV]
        : `${window.location.origin}/api/proxy?url=${ROOTS.host[ENV]}`,
      responseType: 'json',
    }
  }

  /**
   * 请求拦截
   * 1.添加公共参数
   */
  protected interceptorsRequest(): void {
    this.service.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        Object.assign(config, {
          metadata: {startTime: new Date().valueOf()},
        })
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )
  }

  /**
   * 响应拦截
   * 1.打印日志
   * 2.统一处理
   */
  protected interceptorsResponse(): void {
    this.service.interceptors.response.use(
      (response: AxiosResponse) => {
        return this.handleResponse(response)
      },
      (error) => {
        const {response} = error
        if (response === undefined) {
          return Promise.reject(new Error(error))
        }
        return this.handleResponse(response)
      }
    )
  }

  protected handleResponse(
    response: AxiosResponse
  ): Promise<AxiosResponse<any>> {
    if (response.config.xcHideLog) {
      return Promise.resolve(response)
    }
    const {data, status, config, statusText} = response

    const succeed = data.ret === 1 && (response.config.noData || data.data)
    this.responseLog(response, succeed)
    if (succeed) {
      return Promise.resolve(response)
    }
    const msg = data.msg || data.err_msg || data.data?.err_msg
    if (response.config.xcErrorToast) {
      onlyToast(msg)
    }
    return Promise.reject(msg)
  }

  protected responseLog(response: AxiosResponse, succeed: boolean) {
    response.config.metadata.endTime = new Date().valueOf()
    const req = JSON.parse(response.config.data)
    const info: any = {
      mid: req.h_m,
      type: this.IS_NODE ? 'fetchData' : 'http',
      url: `${response.config.baseURL}${response.config.url}`,
      method: response.config.method,
      req,
      res: response.data,
      status: response.status,
      ua: response.config.headers['User-Agent'],
      responseTime:
        response.config.metadata.endTime - response.config.metadata.startTime,
    }
    this.log[succeed ? 'info' : 'error'](info)
  }

  /**
   * 创建唯一实例（单例模式）
   */
  public static getInstance(): MyRequest {
    if (!this.instance) {
      this.instance = new MyRequest()
    }
    return this.instance
  }

  public post<T = any>(
    url: string,
    data: any = {},
    config: AxiosRequestConfig = {}
  ) {
    return this.service.post<T>(url, data, config)
  }

  public outPost<T = any>(
    url: string,
    data: any = {},
    config: AxiosRequestConfig = {}
  ) {
    return this.service.post<T>(url, data, {
      baseURL: ApiHost,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
      ...config,
    })
  }

  public get<T = any>(
    url: string,
    params: any = {},
    config: AxiosRequestConfig = {}
  ) {
    return this.service.get<T>(url, {
      params,
      ...config,
    })
  }
}

export const http = MyRequest.getInstance()
const logFun =
  ({deviceinfo, clientIp, userAgent, queries, path}: RootState['env']) =>
  ({
    action,
    otype,
    data,
    id,
    oid,
    src = 'hiya',
    mid,
    did,
  }: {
    action: string
    otype: string
    data?: any
    id?: any
    oid?: any
    src?: string
    mid?: string
    did?: string
  }) => {
    const commonData = {
      app_name: 'hiya',
      ip: clientIp,
      ua: userAgent,
      path,
      // 全部添加ab实验client_id  默认为 ‘’ 没有不穿设置为undefined
      // client_id: clientId || undefined,
      ...(queries.share_to && {shareTo: queries.share_to}),
      ...(queries.m && {mid: queries.m}),
      ...(queries.d && {did: queries.d}),
      ...(queries.nt && {netType: queries.nt}),
    }
    return http.post(
      '/stat/action',
      {
        ...commonData,
        ...deviceinfo,
        list: [
          {
            action,
            otype,
            data: {
              mid: deviceinfo.h_m,
              ...data,
              st: Date.now(),
              // eslint-disable-next-line no-plusplus
              logId: `${Math.floor(Date.now() / 1000)}`,
            },
            ...(id && {id}),
            ...(oid && {oid}),
            ...(src && {src}),
          },
        ],
        ...(mid && {h_m: Number(mid)}),
        ...(did && {h_did: did}),
      },
      {
        baseURL: `${window.location.origin}/host`,
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
        xcHideLog: true,
      }
    )
  }
export const log = createAsyncThunk<
  void,
  {
    action: string
    otype: string
    data?: any
    id?: any
    oid?: any
    src?: string
    mid?: string
    did?: string
  }
>('log', async (arg, store) => {
  await logFun(store.getState().env)(arg)
})
export function useLog() {
  const env = useSelector((state: any) => {
    return state.env
  })
  return logFun(env)
}
